export default {
    1: {
        colours: {
            primary: '#ee7534',
            secondary: '#f58b3c',
            textDark: '#f58b3c',
            textDarkHover: '#e46526',
            textWhite: '#f58b3c',
            textWhiteHover: '#e46526',
        },
        images: {
            logo: 'img/logo-base.png',
            logoFull: 'img/logo-full.png',
        },
        text: {
            phone: '+61 2 9907 2211',
            email: 'info@aluxor.com.au',
            website: 'www.aluxor.com.au',
            address1: '22/9 Powells Road',
            address2: 'Brookvale, NSW 2100',
            openTimes: {
                weekday: '7:30 am - 3:30 pm',
                weekend: 'Closed',
            },
            dftLicense: 'NSW DFT Licence 241699C',
            abn: '43 326 634 246',
            bankDetails: {
                bankName: 'Commonwealth Bank',
                accountName: 'Aluxor Industries Pty Ltd',
                bsb: '062-000',
                accountNumber: '1165 5586',
                address: 'PO Box 7464, WARRINGAH MALL NSW 2100',
                swiftCode: ''
            },
            shortName: 'Aluxor'
        }
    },
    2: {
        colours: {
            primary: '#003f88',
            secondary: '#00397a',
            textDark: '#7e9ec4',
            textDarkHover: '#1a5294',
            textWhite: '#1a5294',
            textWhiteHover: '#00397a',
        },
        images: {
            logo: 'img/logo-base-nolan.png',
            logoFull: 'img/logo-full-nolan.png',
        },
        text: {
            phone: '1300 35 75 85',
            email: 'melbourne@nolans.com.au',
            website: 'www.nolans.com.au',
            address1: '2 Goodall Close',
            address2: 'Dandenong South, VIC 3175',
            openTimes: {
                weekday: '8:30 am - 4:30 pm',
                weekend: 'Closed',
            },
            dftLicense: '',
            abn: '81 639 242 863',
            bankDetails: {
                bankName: 'Westpac Banking Corporation',
                accountName: 'Nolan.UDA Pty Limited',
                bsb: '032-000',
                accountNumber: '358594',
                address: 'PO Box 312, BRAESIDE VIC 3195',
                swiftCode: 'WPACAU2S'
            },
            shortName: 'Nolans'
        }
    }
};